import { HeadlineFour, ParagraphBody } from '@insurely/ui';

import { useLocation } from '@main/shared-exports';

export default function NotFoundScreen() {
  const { pathname } = useLocation();
  return (
    <div>
      <HeadlineFour center margin="top-large">
        Page not found
      </HeadlineFour>
      <ParagraphBody center>{pathname}</ParagraphBody>
    </div>
  );
}
